var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { attrs: { id: "snb" } }, [
    _c("section", { staticClass: "snb_sec mypage_wrap" }, [
      _c("h2", [_vm._v(_vm._s(_vm.$t("TITLE.GLOBAL.MYPAGE")))]),
      _vm._v(" "),
      _c("div", { staticClass: "list" }, [
        _c(
          "ul",
          { staticClass: "list_mymenu" },
          _vm._l(_vm.myPageList, function(menu) {
            return _c("li", [
              _c(
                "a",
                {
                  attrs: { href: "javascript:" },
                  on: {
                    click: function($event) {
                      return _vm.handleMoveMenu(menu)
                    }
                  }
                },
                [_vm._v(_vm._s(menu.menuNm))]
              )
            ])
          }),
          0
        )
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "snb_sec mymenu_wrap" }, [
      _c("h2", [
        _vm._v(
          "\n            " +
            _vm._s(_vm.$t("TITLE.GLOBAL.MYMENUS")) +
            "\n            "
        ),
        _c(
          "a",
          {
            staticClass: "ico_config",
            attrs: {
              href: "javascript:",
              title: _vm.$t("BUTTON.GLOBAL.CONFIG")
            },
            on: { click: _vm.btnMyMenuConfig }
          },
          [
            _c("span", { staticClass: "sr_only" }, [
              _vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.CONFIG")))
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "list" }, [
        _c(
          "ul",
          { staticClass: "list_mymenu" },
          _vm._l(_vm.myMenusList, function(menu) {
            return _c("li", [
              _c(
                "a",
                {
                  attrs: { href: "javascript:" },
                  on: {
                    click: function($event) {
                      return _vm.handleMoveMenuByMenuId(menu)
                    }
                  }
                },
                [_vm._v(_vm._s(menu.menuNm))]
              )
            ])
          }),
          0
        )
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "snb_sec myctg_wrap" }, [
      _c("h2", [
        _vm._v(
          "\n            " +
            _vm._s(_vm.$t("TITLE.GLOBAL.QUICKCATEGORY")) +
            "\n            "
        ),
        _c(
          "a",
          {
            staticClass: "ico_config",
            attrs: {
              href: "javascript:",
              title: _vm.$t("BUTTON.GLOBAL.CONFIG")
            },
            on: { click: _vm.btnCatConfig }
          },
          [
            _c("span", { staticClass: "sr_only" }, [
              _vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.CONFIG")))
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "list" }, [
        _c(
          "ul",
          { staticClass: "list_quickctg" },
          _vm._l(_vm.quickCategoryList, function(cat) {
            return _c("li", [
              _c(
                "a",
                {
                  attrs: { href: "javascript:" },
                  on: {
                    click: function($event) {
                      return _vm.setCategoryParam(
                        cat.category1,
                        cat.category2,
                        cat.category3
                      )
                    }
                  }
                },
                [_vm._v(_vm._s(cat.categoryNm))]
              )
            ])
          }),
          0
        ),
        _vm._v(" "),
        _vm.isUndo
          ? _c("div", { staticClass: "ctg_btn" }, [
              _c(
                "a",
                {
                  staticClass: "btn_white w100p",
                  attrs: {
                    href: "javascript:",
                    title: _vm.$t("BUTTON.GLOBAL.UNDO")
                  },
                  on: {
                    click: function($event) {
                      return _vm.btnUndo()
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("BUTTON.GLOBAL.UNDO")) +
                      "\n                "
                  )
                ]
              )
            ])
          : _vm._e()
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "bn_wrap" }, [
      _c("ul", { staticClass: "list_banner" }, [
        !_vm.isASC
          ? _c("li", { staticClass: "bn_box" }, [
              _c(
                "a",
                {
                  staticClass: "ico_itvoc",
                  attrs: {
                    href: "javascript:",
                    title: _vm.$t("TITLE.LEFT.MENU.ITVOC")
                  },
                  on: { click: _vm.btnITVOC }
                },
                [_vm._v(_vm._s(_vm.$t("TITLE.LEFT.MENU.ITVOC")))]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("li", { staticClass: "bn_box" }, [
          _c(
            "a",
            {
              staticClass: "ico_support",
              attrs: {
                href: "javascript:",
                title: _vm.$t("TITLE.LEFT.MENU.SUPPORT")
              },
              on: { click: _vm.btnSupport }
            },
            [_vm._v(_vm._s(_vm.$t("TITLE.LEFT.MENU.SUPPORT")))]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ace30c38", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ace30c38","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/main/SKPSnb.vue
// module id = 8lIf
// module chunks = 0